import { WheelRaffleItemStatus } from "./types";
import type { RaffleBase, RecentRaffle } from "./types";

export type RaffleRole = "created" | "joined";

// Свой розыгрыш считаем созданным, даже если создатель в нём участвует.
export const getRaffleRole = (raffle: RaffleBase): RaffleRole | null => {
  if (raffle.is_creator) return "created";
  // Победитель — тоже участник, даже если бэк не проставил is_participant.
  if (raffle.is_participant || raffle.is_winner) return "joined";
  return null;
};

// Последние по времени окончания — сверху.
const compareHistory = (a: RecentRaffle, b: RecentRaffle): number =>
  Date.parse(b.drawn_at ?? b.ends_at) - Date.parse(a.drawn_at ?? a.ends_at);

// recent отдаёт и текущие (они уже на табло), и чужие — оставляем
// только свои разыгранные.
const isInHistory = (raffle: RecentRaffle): boolean =>
  raffle.status === WheelRaffleItemStatus.DRAWN &&
  getRaffleRole(raffle) !== null;

export const selectHistory = (raffles: RecentRaffle[]): RecentRaffle[] =>
  raffles.filter(isInHistory).sort(compareHistory);
